module.exports = __webpack_public_path__ + "2af1e8ee3942b1faf987d690dafc182e.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_2-872.webp
// module id = 585
// module chunks = 0